var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
import React, { useEffect, useRef } from 'react';
import GridComponent from '../GridComponent/GridComponent';
import { CalendarBarComponent } from '../CalendarBarComponent/CalendarBarComponent';
import { useAppDispatch, useAppSelector } from '../../store/app.store';
// import { getFormattedDate } from '../../../Utils/DateUtils';
//import { fetchAssignmentData } from '../../Store/Thunks/AssignmentDetailsThunks';
// import {
//   getNonProjectForecast,
//   getResourceForecast,
// } from '../../Store/Thunks/ResourceForecastThunks';
//import { useMasterData } from '../../Utils/ContextHelper';
//import { fetchProfileDetails } from '../../Store/Thunks/ProfileDetailsThunks';
//import { fetchNPEventTypes } from '../../Store/Thunks/DomainDataThunks';
//import { getActualLaborHours } from '../../Store/Thunks/LaborThunks';
import StickyFooterComponent from '../StickyFooterComponent/StickyFooterComponent';
import { MessageBar } from '@fluentui/react';
import { useSelector } from 'react-redux';
//import { isISDForecastLoadingSelector } from '../../Store/Slices/assignmentForecastHoursSlice';
//import { isNPForecastLoadingSelector } from '../../Store/Slices/NonProjectHoursSlice';
// import { TelemetryService } from '../../Services/TelemetryService';
// import { EventCodes } from '../../Constants/TelemetryConstants';
import { FXPServiceCatalog, FxpServiceFactory } from '@fxp/fxpservices-di';
import { TelemetryService } from '../../services/TelemetryService';
import { EventCodes, TelemetryActions, TelemetryAppConstants } from '../../../common/TelemetryConstants';
import { fetchAssignmentDetails } from '../../store/Thunks/AssignmentDetailsThunks';
import { dailyGrainDateListSelector } from '../../store/Slices/DateNavigationSlice';
import { isAssignmentDetailsLoadedSelector } from '../../store/Slices/AssignmentDetailsSlice';
import LoaderComponent from '../LoaderComponent/LoaderComponent';
import { notificationsSelector, RA_REMOVE_NOTIFICATION } from '../../store/Slices/MessageBarSlice';
import { addDays, startOfDay } from 'date-fns';
export default function GridViewComponent() {
    const [selectedDate, setSelectedDate] = React.useState(() => {
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.includes('?') ? hash.split('?')[1] : '');
        const inputDate = params === null || params === void 0 ? void 0 : params.get('start-date');
        if (inputDate && !isNaN(Date.parse(inputDate))) {
            return new Date(inputDate);
        }
        return new Date();
    });
    // const {
    //   isProfileDetailsLoaded,
    //   isNPEventsLoaded,
    //   getNPEventTypes,
    //   updateProfileData,
    //   setFeatureFlagInProgress,
    //   setExperienceEnabled,
    //   isExperienceEnabled,
    //   isFeatureFlagInProgress,
    //   profileDetails,
    //   isNPEventsLoading,
    //   isProfileDetailsLoading,
    // } = useMasterData();
    // Dummy data for testing
    const isExperienceEnabled = true; //isExperienceEnabled;
    const isFeatureFlagInProgress = false; //isFeatureFlagInProgress;
    const isProfileDetailsLoaded = true; //isProfileDetailsLoaded;
    const isNPEventsLoaded = true; //isNPEventsLoaded;
    const isISDForecastLoadingSelectorFlag = false; //isISDForecastLoadingSelectorFlag;
    const isNPForecastLoadingSelectorFlag = false; //isNPForecastLoadingSelectorFlag;
    const profileDetails = {
        Alias: 'testAlias',
        BusinessRoleId: 'testBusinessRoleId',
    }; //profileDetails;
    const [isPastView, setPastView] = React.useState(false);
    const dispatch = useAppDispatch();
    const notification = useAppSelector(notificationsSelector);
    //const isISDForecastLoadingSelectorFlag = useSelector(isISDForecastLoadingSelector);
    //const isNPForecastLoadingSelectorFlag = useSelector(isNPForecastLoadingSelector);
    /*const telemetryService = new TelemetryService();
    const methodName = "ComponentLoadTime";
    const [logEvents] = React.useState(
            telemetryService.createPropertyBag()
    );*/
    const [isPageLoading, setPageLoading] = React.useState(true);
    const startLoadTime = useRef(null);
    const currentDate = new Date();
    const userInfo = FxpServiceFactory.getServiceInstance(FXPServiceCatalog.UserInfoService);
    const useralias = userInfo.getCurrentUser();
    const dateHeader = useSelector(dailyGrainDateListSelector);
    const startDate = dateHeader[0];
    const endDate = dateHeader[dateHeader.length - 1];
    const isAssignmentDetailsLoading = useSelector(isAssignmentDetailsLoadedSelector);
    // Calculate dynamic grid width based on number of date columns
    const calculateGridWidth = (numberOfColumns) => {
        const baseWidth = 2066; // Base width for 10 columns
        const baseColumns = 10;
        const columnWidth = 140; // Width per additional column
        if (numberOfColumns <= baseColumns) {
            return baseWidth;
        }
        else {
            const additionalColumns = numberOfColumns - baseColumns;
            return baseWidth + (additionalColumns * columnWidth);
        }
    };
    const gridWidth = calculateGridWidth(dateHeader.length);
    const fetchData = () => {
        if (selectedDate && isProfileDetailsLoaded) {
            // var formattedStartDate = getFormattedDate(selectedDate);
            var endDate = new Date(selectedDate);
            endDate.setDate(selectedDate.getDate() + 8 * 7 - 1);
            // var formattedEndDate = getFormattedDate(endDate);
            /*dispatch(
              fetchAssignmentData(
                profileDetails,
                formattedStartDate,
                formattedEndDate
              ) as any
            );
            dispatch(
              getResourceForecast(
                profileDetails,
                formattedStartDate,
                formattedEndDate
              ) as any
            );
            dispatch(
              getNonProjectForecast(
                profileDetails.Alias,
                formattedStartDate,
                formattedEndDate
              ) as any
            );*/
            const enablePastView = startOfDay(addDays(selectedDate, 13)) < startOfDay(new Date());
            setPastView(enablePastView);
            /*dispatch(
              getActualLaborHours(
                profileDetails.Alias,
                formattedStartDate,
                8,
                enablePastView
              )
            );*/
        }
    };
    useEffect(() => {
        fetchData();
    }, [profileDetails, selectedDate, dispatch]);
    /*useEffect(() => {
      if (!isNPEventsLoaded && !isNPEventsLoading) {
        dispatch(fetchNPEventTypes(getNPEventTypes));
      }
      if (!isProfileDetailsLoaded && !isProfileDetailsLoading) {
        dispatch(fetchProfileDetails(updateProfileData));
      }
    }, [getNPEventTypes, updateProfileData]);*/
    useEffect(() => {
        //capture page load start time for telemetry
        startLoadTime.current = new Date();
        // setFeatureFlagInProgress(true);
        // const fetchFeatureFlagData = async () => {
        //   const response = await evaluateFeatureFlag(
        //     Constants.FlightingConstants.ApplicationName,
        //     appSettings(process.env.ENV_NAME).AppConfiguration.EnvironmentName,
        //     Constants.FlightingConstants.E360Features,
        //     'Alias,BusinessRoleId'
        //   );
        //   setFeatureFlagInProgress(false);
        //   setExperienceEnabled(response.HasAccessToE360Availability);
        // };
        // fetchFeatureFlagData();
        // setFeatureFlagInProgress(false);
        // setExperienceEnabled(true);
    }, []);
    useEffect(() => {
        //capture page load end time for telemetry
        if (isPageLoading && !isISDForecastLoadingSelectorFlag && !isNPForecastLoadingSelectorFlag) {
            const endLoadTime = new Date();
            setPageLoading(false);
            if (startLoadTime.current) {
                const loadTimeDifference = endLoadTime.getTime() - startLoadTime.current.getTime();
            }
        }
    }, [isISDForecastLoadingSelectorFlag, isNPForecastLoadingSelectorFlag]);
    useEffect(() => {
        if (useralias && startDate && endDate) {
            dispatch(fetchAssignmentDetails(useralias, startDate, endDate));
            // Log Resource Availability Fetched From Esxp
            const telemetryService = TelemetryService.getInstance();
            telemetryService.logEvent(EventCodes.Ev0008, TelemetryActions.PageVisit, 'Resource Availability Fetched From Esxp', {
                AppId: TelemetryAppConstants.AppId,
                ParentAppId: TelemetryAppConstants.ParentAppId,
                UPN: useralias,
                Channel: 'ESXP',
                Timestamp: new Date().toISOString(),
                ResultCode: 'Success',
                AiInitiativeName: 'Availability Agent',
                IsAllowListed: true
            }, null, false);
        }
    }, [useralias, startDate, endDate, dispatch]);
    // Listen for hashchange and Enter key in address bar to update selectedDate
    useEffect(() => {
        const updateDateFromHash = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.includes('?') ? hash.split('?')[1] : '');
            const inputDate = params === null || params === void 0 ? void 0 : params.get('start-date');
            if (inputDate && !isNaN(Date.parse(inputDate))) {
                setSelectedDate(new Date(inputDate));
            }
        };
        // Listen for hashchange
        window.addEventListener('hashchange', updateDateFromHash);
        // Listen for Enter key (in case browser doesn't fire hashchange)
        const onKeyDown = (e) => {
            if (e.key === 'Enter') {
                updateDateFromHash();
            }
        };
        window.addEventListener('keydown', onKeyDown);
        return () => {
            window.removeEventListener('hashchange', updateDateFromHash);
            window.removeEventListener('keydown', onKeyDown);
        };
    }, []);
    return isFeatureFlagInProgress ? (React.createElement("p", null, " Feature flag call in progress...")) : isExperienceEnabled ? (React.createElement("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            paddingLeft: '10px',
            width: `${gridWidth}px`
        } },
        !!notification && notification.length > 0 && notification.map(notification => notification.show ? (React.createElement(MessageBar, { key: notification.id, messageBarType: notification.messageBarType, onDismiss: () => dispatch(RA_REMOVE_NOTIFICATION(notification.id)), dismissButtonAriaLabel: "Close", isMultiline: false }, notification.message)) : null),
        React.createElement("div", null,
            React.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                } },
                React.createElement(CalendarBarComponent, { selectedDate: selectedDate, setSelectedDate: setSelectedDate }),
                React.createElement("div", { style: {
                        display: 'flex',
                        flexDirection: 'row',
                        paddingTop: '15px',
                        paddingRight: '20px',
                    } })),
            isAssignmentDetailsLoading ? React.createElement(LoaderComponent, { primaryText: 'Fetching Assignment Details' }) : React.createElement(GridComponent, { isPastView: isPastView })),
        React.createElement("div", null, isAssignmentDetailsLoading ? React.createElement(React.Fragment, null) : React.createElement(StickyFooterComponent, { isPastView: isPastView })))) : (React.createElement("p", null, "Feature not available"));
}
//# sourceMappingURL=GridViewComponent.js.map